import {originMapping} from "./consts.js";
import common from "@well-b/well-b-shared";
import {Config, ConfigProps} from "./Config.js";

export const getThemeByOrigin = originUrl => {
    try {
        const hostname = new URL(originUrl).hostname;
        const theme = originMapping[hostname];
        return theme || common.themeNames.wellB;
    } catch (e) {
        console.error({error: e.message, stack: e.stack});
    }
};

export const getUnauthorizedSystemRedirectUrl = systemId => {
    const systemIdToSystemRedirectWeb = Config.envJson(ConfigProps.SYSTEM_ID_TO_SYSTEM_UNAUTHORIZED_REDIRECT_URL);
    return (
        systemIdToSystemRedirectWeb[systemId?.toLowerCase()] ??
        `/login?returnTo=${encodeURIComponent(window.location.href)}`
    );
};
